import { FormGroup } from '@angular/forms';

import { ExportConfigFormHelper } from './abstract-export-template-form-helper';
import { ExportConnectorEntity } from './export-connector.entity';
import {
	ExportFormat,
	ExportTemplateDetailsEntity,
} from './export-template-details.entity';
import type { ExportTemplateDetailsForm } from './export-template-details.form';

// Returned when no concrete helper matches - typically because the export type
// is not set yet. Doing nothing is correct here: the form is mid-construction
// and a later populate/update with a real type will build it properly.
export class NoopExportFormHelper extends ExportConfigFormHelper {
	protected buildCompletePayload(
		commonConfig: ExportTemplateDetailsEntity,
		_form: FormGroup
	): ExportTemplateDetailsEntity {
		return commonConfig;
	}

	protected populateWithConfig(
		_entity: ExportTemplateDetailsEntity,
		_form: ExportTemplateDetailsForm
	): void {
		return;
	}

	protected updateWithConfig(
		_connector: ExportConnectorEntity,
		_exportType: ExportFormat,
		_form: ExportTemplateDetailsForm
	): void {
		return;
	}
}
